// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
var AgentInfo__Jsx3 = require("../../../uikit/reason/atoms/AgentInfo/AgentInfo__Jsx3.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var TerminatedAgentIconOverlay = require("../../common/Agent/TerminatedAgentIconOverlay.bs.js");
var ClientPageMatchCardAgent_agent_graphql = require("../../../__generated__/ClientPageMatchCardAgent_agent_graphql.bs.js");

var convertFragment = ClientPageMatchCardAgent_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ClientPageMatchCardAgent_agent_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ClientPageMatchCardAgent_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ClientPageMatchCardAgent_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ClientPageMatchCardAgent_agent_graphql.node, convertFragment, fRef);
}

var Fragment_membershipStatusV5_decode = ClientPageMatchCardAgent_agent_graphql.Utils.membershipStatusV5_decode;

var Fragment_membershipStatusV5_fromString = ClientPageMatchCardAgent_agent_graphql.Utils.membershipStatusV5_fromString;

var Fragment = {
  membershipStatusV5_decode: Fragment_membershipStatusV5_decode,
  membershipStatusV5_fromString: Fragment_membershipStatusV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ClientPageMatchCardAgent(props) {
  var __size = props.size;
  var size = __size !== undefined ? __size : "xSmall";
  var agent = use(props.agent);
  var match = agent.membershipStatus;
  if ((match === "ACTIVE" || match === "TERMINATED") && match !== "ACTIVE") {
    return JsxRuntime.jsx(TerminatedAgentIconOverlay.make, {
                size: size,
                children: JsxRuntime.jsx(AgentInfo__Jsx3.make, {
                      avatar: AvatarSrcUrl.place_holder,
                      size: size,
                      name: agent.displayName,
                      brokerage: "NO LONGER ON TAN"
                    })
              });
  }
  var match$1 = agent.profilePhoto;
  var avatar = match$1 !== undefined ? match$1.url : AvatarSrcUrl.place_holder;
  return JsxRuntime.jsx(AgentInfo__Jsx3.make, {
              avatar: avatar,
              size: size,
              name: agent.displayName,
              brokerage: agent.brokerage,
              wrapName: (function (name) {
                  return JsxRuntime.jsx(ButtonsV5.Link.make, {
                              href: "/agents/" + agent.id,
                              onClick: (function (e) {
                                  e.stopPropagation();
                                }),
                              children: Caml_option.some(JsxRuntime.jsx("div", {
                                        children: name,
                                        className: "font-medium"
                                      }))
                            });
                }),
              children: Caml_option.some(null)
            });
}

var make = ClientPageMatchCardAgent;

exports.Fragment = Fragment;
exports.make = make;
/* ButtonsV5 Not a pure module */
